import React from 'react';
import { ListPaginationContextValue } from './types';

export const ListPaginationContext = React.createContext<ListPaginationContextValue | null>(null);

export function useListPaginationContext(): ListPaginationContextValue {
    const context = React.useContext(ListPaginationContext);
    if (!context) {
        throw new Error('useListPaginationContext must be used within a List');
    }
    return context;
}
